module.exports = __webpack_public_path__ + "static/media/proj8_img4.55e5f3b1.jpg";